import moment from 'moment-timezone';
import { SuggestedSchedules, TimeSlots } from '../types';

/*
1. Next Working Day Morning
2. Next Working Day Afternoon
3. Next Monday morning from Next Working Day
*/

export const getSuggestedSchedules = (
  timezone: string,
): SuggestedSchedules[] => {
  const receiverDate = moment()
    .tz(timezone || null)
    .startOf('day');
  const tomorrow = receiverDate.clone().add(1, 'days');
  const isTomorrowWorkingDay = ![0, 6].includes(tomorrow.day());

  const nextWorkingDayMorning = isTomorrowWorkingDay
    ? tomorrow.clone().hour(9)
    : tomorrow.clone().day(8).hour(9);
  const nextWorkingDayAfternoon = isTomorrowWorkingDay
    ? tomorrow.clone().hour(14)
    : tomorrow.clone().day(8).hour(14);
  const nextMondayOrTuesdayMorning = isTomorrowWorkingDay
    ? tomorrow.clone().day(8).hour(9)
    : tomorrow.clone().day(9).hour(9);

  return [
    {
      id: 'S0',
      title: `${
        isTomorrowWorkingDay ? 'Tomorrow' : nextWorkingDayMorning.format('dddd')
      } morning`,
      displayDate: nextWorkingDayMorning.format('MMM D, h:mm A'),
      date: nextWorkingDayMorning.toISOString(),
    },
    {
      id: 'S1',
      title: `${
        isTomorrowWorkingDay
          ? 'Tomorrow'
          : nextWorkingDayAfternoon.format('dddd')
      } afternoon`,
      displayDate: nextWorkingDayAfternoon.format('MMM D, h:mm A'),
      date: nextWorkingDayAfternoon.toISOString(),
    },
    {
      id: 'S2',
      title: `${isTomorrowWorkingDay ? 'Monday' : 'Tuesday'} morning`,
      displayDate: nextMondayOrTuesdayMorning.format('MMM D, h:mm A'),
      date: nextMondayOrTuesdayMorning.toISOString(),
    },
  ];
};
